import React, { useState } from 'react';
import { Controller } from 'react-hook-form';
import { Autocomplete } from '@mui/material';
import { FormHelperText, InputAdornment, InputLabel, TextField } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import { withStyles } from '@mui/styles';
import { LabelWithToolTip, Icons } from 'components';
import { LabelLine } from 'components/InputV2/components';
import dealingListServices from './services/DealingListServices';
import { useStyles } from './style';

const BootstrapInput = withStyles((theme) => ({
  root: {
    'label + &': {
      marginTop: theme.spacing(1),
    },
    '& .MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"] .MuiAutocomplete-input': {
      padding: '1.5px 4px',
    },
    '& .MuiInputLabel-formControl': {
      top: '-7px',
      color: '#546e7a',
      fontSize: '12px',
    },
    '& .MuiInputAdornment-root': { color: '#546e7a' },
  },
}))(TextField);



const DealingList = ({
  errors,
  control,
  name,
  defaultValue = null,
  required = false,
  label = 'نام ذینفع',
  tooltip,
}) => {
  const classes = useStyles();
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);

  const getList = async (val) => {
    if (val.length > 2) {
      if (list.length > 0) {
        const index = list.findIndex((item) => {
          return item.name === val || item.id.toString() === val;
        });

        if (index > -1) {
          return;
        }
      }

      setLoading(true);

      const params = {};
      try {
        if (isNaN(val)) {
          params.query = val;
        } else {
          params.businessId = val;
        }

        const result = await dealingListServices.getDealingList(params);
        const data = result.result;

        if (data.length > 0) {
          const list = data.map((val) => ({
            name: `${val.business.name} (${val.business.id})`,
            id: val.business.id,
          }));

          setList(list);
        }
      } catch (e) { }

      setLoading(false);
    }
  };

  return (
    <Controller
      name={name}
      render={({ field: { onChange, value } }) => (
        <Autocomplete
          style={{ marginTop: 0 }}
          disableClearable
          selectOnFocus
          onChange={(event, newValue) => {
            if (newValue) {
              onChange(newValue);
            }
          }}
          className={classes.root}
          onInputChange={(event, newInputValue) => {
            if (newInputValue) {
              getList(newInputValue);
            }
          }}
          filterOptions={(options, params) => {
            const filtered = options.filter((item) => {
              return (
                item.id.toString().search(params.inputValue) > -1 ||
                item.name.search(params.inputValue) > -1
              );
            });

            return filtered;
          }}
          id="dealer-list"
          isOptionEqualToValue={(option, value) => option.id === value.id}
          getOptionLabel={(option) => option.name}
          options={list}
          value={value}
          loading={loading}
          renderInput={(params) => (
            <>
              <InputLabel shrink htmlFor={params?.name} className={classes.label}>
                <LabelLine
                  label={<LabelWithToolTip label={label} description={tooltip} />}
                  required={required}
                />
              </InputLabel>
              <BootstrapInput
                {...params}
                variant="outlined"
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <>
                      {loading && <CircularProgress color="inherit" size={20} />}
                      {params.InputProps.endAdornment}
                    </>
                  ),
                  startAdornment: (
                    <InputAdornment position="start">
                      <Icons icon='Search' color="#546e7a" size="18" />
                    </InputAdornment>
                  ),
                }}
              />
              <FormHelperText id="my-helper-text" className={classes.asterisk}>
                {errors?.[name]?.message}
              </FormHelperText>
            </>
          )}
        />
      )}
      control={control}
      rules={{
        required: required ? 'پر کردن فیلد الزامی است' : required,
      }}
      defaultValue={defaultValue}
    />
  );
};

export default DealingList;
